import { Eyebrow } from "@/components/shared";
import { Server, ShieldCheck, Activity, HardDrive, Bell, RefreshCw, Network, Lock, Terminal, DollarSign, Database, Cpu } from "lucide-react";

const features = [
  [Server, "Managed PBS 4.x", "Every customer gets a dedicated, isolated Proxmox Backup Server — installed, patched and monitored for you."],
  [HardDrive, "Dedup-aware storage", "Track logical protected data and actual cloud usage. See your deduplication savings in real time."],
  [ShieldCheck, "Backup verification", "Backups aren't useful unless they restore. We verify snapshot integrity automatically, on schedule."],
  [Activity, "Smart health monitoring", "We detect missed jobs, failed jobs, duration anomalies and storage growth — not just up/down."],
  [Bell, "Rich notifications", "Email, webhook, Slack-ready and Teams-ready alerts with per-category immediate or digest delivery."],
  [Network, "Optional WireGuard", "Generate a private tunnel with QR + config files. Only backup services are exposed."],
  [RefreshCw, "Automated pruning & GC", "Retention presets keep your datastore healthy without manual maintenance."],
  [Lock, "Client-side encryption", "Bring your own encryption key. Your private key stays with you — never with us."],
  [Terminal, "Connection wizard", "Paste supplied values into Proxmox, or run the generated CLI command. Copy buttons everywhere."],
  [DollarSign, "Predictable billing", "Stripe-powered subscriptions with proration, upgrades, invoices and instant storage expansion."],
  [Database, "Restore Center", "Find any snapshot by VM/CT, date and verification status with precise restore instructions."],
  [Cpu, "Native performance", "Direct-to-datastore backups over TLS or WireGuard with latency and throughput testing."],
];

export default function Features() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-20 sm:px-6 lg:px-8">
      <Eyebrow>Features</Eyebrow>
      <h1 className="max-w-3xl font-display text-4xl font-extrabold tracking-tight text-slate-50 sm:text-5xl">Everything a managed offsite backup platform should do.</h1>
      <p className="mt-4 max-w-2xl text-slate-400">From provisioning to verification to disaster recovery — ZettaKeep handles the infrastructure so you can focus on your VMs.</p>
      <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {features.map(([Icon, t, d]) => (
          <div key={t} className="rounded-xl border border-slate-800 bg-slate-900/40 p-6 transition-colors hover:border-cyan-500/30">
            <Icon className="h-6 w-6 text-cyan-400" />
            <div className="mt-4 font-display font-semibold text-slate-100">{t}</div>
            <p className="mt-1.5 text-sm text-slate-400">{d}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
